import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from 'components/dialog'
import CustomAvailabilityForm from './custom-availability-form'

const useStyles = makeStyles(theme => ({
  header: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
}))

const CustomAvailabilityFormDialog = ({ facilities, onSuccess }) => {
  const classes = useStyles()

  return (
    <Dialog
      trigger={
        <Button
          variant="outlined"
          color="primary"
          startIcon={<AddOutlinedIcon />}
        >
          Add Custom Availability
        </Button>
      }
      maxWidth="sm"
      fullWidth
      showCloseButton
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle className={classes.header}>
            Add Custom Availability
          </DialogTitle>
          <DialogContent>
            <Box py={2}>
              <CustomAvailabilityForm
                facilities={facilities}
                onSuccess={() => {
                  onSuccess && onSuccess()
                  closeDialog()
                }}
                onCancel={closeDialog}
              />
            </Box>
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default CustomAvailabilityFormDialog
